module.exports = __webpack_public_path__ + "static/Function_Rm_1-97df9d0afadf7c6ac11432bc7b1bcf97.jpg";